module.exports = __webpack_public_path__ + "img/enter_otp_logo.a492d2c3.png";